/**
 * Translation Manager for Letz AI
 * Handles all translations for the image generator
 */
class TranslationManager {
  constructor() {
    this.translations = {};
    this.init();
  }

  init() {
    // Try to get translations from data attribute
    const aiWrapper = document.querySelector('[data-translations]');
    if (aiWrapper) {
      try {
        const translationsData = aiWrapper.getAttribute('data-translations');
        if (translationsData) {
          this.translations = JSON.parse(translationsData);
          console.log('[TranslationManager] Translations loaded:', this.translations);
        }
      } catch (error) {
        console.error('[TranslationManager] Error parsing translations:', error);
        this.setDefaultTranslations();
      }
    } else {
      this.setDefaultTranslations();
    }
  }

  setDefaultTranslations() {
    // Fallback translations in case Shopify translations are not available
    this.translations = {
      letz_ai: {
        title_prefix: "Inteligência Artística by ",
        brand_name: "Letz AI",
        select_image: "Selecione a imagem",
        exclusive_arts: "Artes exclusivas",
        from_this_product: "Deste produto",
        input_title_default: "O que você deseja por no Quadro?",
        select_combination: "Selecione a combinação",
        toasts: {
          invalid_file_type: "Apenas arquivos de imagem são permitidos",
          file_too_large: "Arquivo muito grande. Máximo 50MB permitido",
          file_too_large_general: "Arquivo muito grande. Máximo 50MB.",
          image_loaded_success: "Imagem carregada com sucesso",
          image_process_error: "Erro ao processar imagem",
          image_process_error_retry: "Erro ao processar imagem. Tente novamente.",
          image_loaded_processed_success: "Imagem carregada e processada com sucesso!",
          file_read_error: "Erro ao ler arquivo",
          processing_orientation: "Processando orientação da imagem...",
          select_palette: "Por favor, selecione uma paleta de cores para este tipo de produto.",
          enter_item: "Por favor, insira um item para o quadro",
          enter_item_required: "Por favor, insira um item para o quadro.",
          generated_success: "Gerado com sucesso",
          session_expired: "Sessão expirada. Por favor, faça login para continuar.",
          session_expired_login: "Sessão expirada. Por favor, faça login novamente.",
          art_removed_success: "Arte removida com sucesso",
          redirecting_login: "Redirecionando para o login...",
          login_success: "Login realizado com sucesso! Agora você pode gerar imagens.",
          login_required: "Para gerar imagens, você precisa estar logado na sua conta.",
          image_restored_success: "Imagem restaurada com sucesso!",
          image_restore_error: "Erro ao restaurar imagem",
          prompt_copied: "Prompt copiado para a área de transferência!",
          prompt_copy_error: "Não foi possível copiar o prompt",
          featured_images_protected: "Imagens em destaque não podem ser removidas",
          wait_generation_finish: "Aguarde a geração terminar antes de remover",
          wait_generation_finish_any: "Aguarde a geração terminar antes de remover qualquer imagem",
          image_auto_loaded: "Imagem carregada automaticamente!",
          loading_image: "Carregando imagem...",
          converting_heic: "Convertendo imagem HEIC...",
          heic_converted_success: "Imagem HEIC convertida com sucesso!",
          url_image_load_error: "Erro ao carregar imagem da URL",
          select_image_files_only: "Por favor, selecione apenas arquivos de imagem.",
          filter_apply_error: "Erro ao aplicar filtro",
          load_more_images_error: "Erro ao carregar mais imagens",
          apply_art_error: "Erro ao aplicar arte: {error}",
          remove_art_error: "Erro ao remover arte: {error}",
          generate_image_error: "Erro ao gerar imagem: {error}",
          image_not_from_product: "Esta imagem não é deste produto"
        }
      }
    };
  }

  /**
   * Get a value by key from translations object
   * @param {string} key - The translation key
   * @returns {any|null} The value or null if not found
   */
  getValue(key) {
    const keys = key.split('.');
    let value = this.translations;

    // Navigate through nested keys
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        return null; // Key not found
      }
    }

    return value;
  }

  /**
   * Get a translation by key
   * @param {string} key - The translation key (e.g., 'toasts.invalid_file_type')
   * @param {Object} params - Parameters for interpolation (e.g., {error: 'message'})
   * @returns {string} The translated text
   */
  t(key, params = {}) {
    // Try to get the value directly
    let value = this.getValue(key);
    
    // If not found and key starts with 'toasts.', try with 'letz_ai.' prefix
    if (value === null && key.startsWith('toasts.')) {
      value = this.getValue(`letz_ai.${key}`);
    }
    
    // If still not found, return the key
    if (value === null) {
      console.warn(`[TranslationManager] Translation key not found: ${key}`);
      return key;
    }

    // If it's not a string, return the key
    if (typeof value !== 'string') {
      console.warn(`[TranslationManager] Translation value is not a string: ${key}`);
      return key;
    }

    // Replace parameters in the translation
    let translatedText = value;
    Object.keys(params).forEach(param => {
      const placeholder = `{${param}}`;
      translatedText = translatedText.replace(new RegExp(placeholder, 'g'), params[param]);
    });

    return translatedText;
  }

  /**
   * Check if translation manager is ready
   * @returns {boolean}
   */
  isReady() {
    return Object.keys(this.translations).length > 0;
  }
}

// Create global instance
window.letzAiTranslations = new TranslationManager();

// Helper function for easy access
window.t = function(key, params = {}) {
  return window.letzAiTranslations.t(key, params);
};

console.log('[TranslationManager] Translation system initialized');